import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/close.png'


const _withScopeId = n => (_pushScopeId("data-v-3e29f0cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-modal" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "register-form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, "注册登录", -1))
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label required" }, "公司名称", -1))
const _hoisted_8 = { class: "form-item-content" }
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = { class: "flex-box" }
const _hoisted_11 = { class: "flex-grow form-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label required" }, "联系人", -1))
const _hoisted_13 = { class: "form-item-content" }
const _hoisted_14 = {
  key: 0,
  class: "error"
}
const _hoisted_15 = { class: "flex-grow form-item tel-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label required" }, "联系方式", -1))
const _hoisted_17 = { class: "form-item-content" }
const _hoisted_18 = {
  key: 0,
  class: "error"
}
const _hoisted_19 = { class: "form-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label required" }, "会议名称", -1))
const _hoisted_21 = { class: "form-item-content" }
const _hoisted_22 = {
  key: 0,
  class: "error"
}
const _hoisted_23 = { class: "form-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label required" }, "所属类型（行业）", -1))
const _hoisted_25 = { class: "form-item-content" }
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = { class: "form-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label required" }, "需要的服务", -1))
const _hoisted_29 = { class: "form-item-content" }
const _hoisted_30 = {
  key: 0,
  class: "error"
}

import { ref, reactive, toRefs, computed, unref } from "vue";
import { checkValue } from "../form/util";
import { LabelRule } from "../form";
import { useStore } from "vuex";
import ToastComp from "../components/ToastComp.vue";

interface Form {
  [x: string]: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginModal',
  props: { visible: Boolean },
  emits: ["update:visible"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const props = __props;
const { visible } = toRefs(props);
const emit = __emit;
const show = computed({
  get() {
    return visible.value;
  },
  set(val) {
    emit("update:visible", val);
  },
});

const form = reactive<Form>({
  company: "",
  contacts: "",
  tel: "",
  meeting: "",
  industry: "",
  serve: "",
});
const errorList = reactive<Form>({
  company: "",
  contacts: "",
  tel: "",
  meeting: "",
  industry: "",
  serve: "",
});
const rules: { [key: string]: LabelRule[] } = {
  // company: [{ required: true, message: "请输入公司名称" }],
  // contacts: [{ required: true, message: "请输入联系人" }],
  // tel: [
  //   { required: true, message: "请输入手机号码" },
  //   { regex: "^1[3-9]\\d{9}$", message: "请输入正确的手机号码" },
  // ],
  // meeting: [{ required: true, message: "请输入会议名称" }],
  // industry: [{ required: true, message: "请输入所属类型（行业）" }],
  // serve: [{ required: true, message: "请输入需要的服务" }],
};
const msg = ref("");
const showMsg = ref(false);
const loading = ref(false);
const cleanForm = (formData: Form) => {
  for (let key in formData) {
    formData[key] = "";
  }
};
const checkItem = (key: string) => {
  let value = form[key];
  let rule = rules[key];
  const tip = checkValue(rule, value);
  errorList[key] = tip;
  return tip;
};
const change = (e: Event, key: string) => {
  checkItem(key);
};
const submit = () => {
  if (unref(loading)) {
    return;
  }
  loading.value = true;
  cleanForm(errorList);
  let flag = true;
  for (let key in form) {
    const tip = checkItem(key);
    if (tip && flag) {
      flag = false;
    }
  }
  if (flag) {
    store.commit("setUser", form);
    msg.value = "注册成功";
    showMsg.value = true;
    show.value = false;
  }
  loading.value = false;
};
const close = () => {
  show.value = false;
  cleanForm(form);
  cleanForm(errorList);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.company) = $event)),
                  placeholder: "请输入公司名称",
                  class: "input-box",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (change($event, 'company')))
                }, null, 544), [
                  [_vModelText, form.company]
                ])
              ]),
              (errorList.company)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(errorList.company), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.contacts) = $event)),
                    placeholder: "请输入联系人",
                    class: "input-box",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (change($event, 'contacts')))
                  }, null, 544), [
                    [_vModelText, form.contacts]
                  ])
                ]),
                (errorList.contacts)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(errorList.contacts), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.tel) = $event)),
                    placeholder: "请输入联系方式",
                    class: "input-box",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (change($event, 'tel')))
                  }, null, 544), [
                    [_vModelText, form.tel]
                  ])
                ]),
                (errorList.tel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(errorList.tel), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.meeting) = $event)),
                  placeholder: "请输入会议名称",
                  class: "input-box",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (change($event, 'meeting')))
                }, null, 544), [
                  [_vModelText, form.meeting]
                ])
              ]),
              (errorList.meeting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(errorList.meeting), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.industry) = $event)),
                  placeholder: "请输入所属类型（行业）",
                  class: "input-box",
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (change($event, 'industry')))
                }, null, 544), [
                  [_vModelText, form.industry]
                ])
              ]),
              (errorList.industry)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(errorList.industry), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.serve) = $event)),
                  placeholder: "请输入需要的服务",
                  class: "input-box",
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (change($event, 'serve')))
                }, null, 544), [
                  [_vModelText, form.serve]
                ])
              ]),
              (errorList.serve)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(errorList.serve), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "common-btn primary submit-btn",
              onClick: submit
            }, "提交")
          ])
        ]),
        _createElementVNode("img", {
          src: _imports_0,
          class: "close-img",
          onClick: close
        })
      ])
    ], 512), [
      [_vShow, show.value]
    ]),
    _withDirectives(_createVNode(ToastComp, {
      show: showMsg.value,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((showMsg).value = $event)),
      message: msg.value
    }, null, 8, ["show", "message"]), [
      [_vShow, showMsg.value]
    ])
  ], 64))
}
}

})